export default __webpack_public_path__ + "static/icon-awtgs-grade-3-260x260-533a5f515433fed55b0ccc8e0ebd7742.jpg";